import { useEffect, useRef, LegacyRef } from 'react';
import Subscribe from '../Subscribe';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import { Upto, TopTip } from '@/components/UI/svg/Wave2';

export default function A() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('wave2portableairconditioner');
    const { locale } = useRouter();
    const viewportRef: LegacyRef<HTMLDivElement> = useRef(null);
    const kvRef: LegacyRef<HTMLDivElement> = useRef(null);

    const toCoupon = () => {
        if (['us', 'ca'].includes(locale)) {
            window.open(`https://${locale}.ecoflow.com/products/wave-2-extra-coupon`, '_blank');
        }
    };

    useEffect(() => {
        // if (viewportRef.current && kvRef.current) {
        //     const offset = kvRef.current.clientHeight / 960;
        //     viewportRef.current.style.zoom = offset.toString();
        //     viewportRef.current.style.height = `calc((50vw - 10px) / ${offset})`;
        // }
        AniContainer.create({
            syncFromTo: [['.wave2-teaser-A .green-text', { opacity: 0 }, { opacity: 1 }]],
            triggerElement: '.wave2-teaser-A .green-text',
            triggerHook: 1,
            offset: '10%',
            duration: '20%',
        });
    }, []);

    return (
        <div className={`wave2-teaser-A ${css.wave2TeaserA}`}>
            {['us', 'ca', 'au'].includes(locale) && (
                <div className="top-tip" onClick={toCoupon}>
                    <TopTip />
                    <p className="text">{t('teaser.top_tip')}</p>
                </div>
            )}
            <div className="img-wrapper" ref={kvRef}>
                <NextImage
                    webpSrc={require('@publicLocal/wave2/kv-pc.webp')}
                    src={require('@publicLocal/wave2/kv-pc.jpg')}
                    alt={t('wave2')}
                    aria-label={t('wave2')}
                />
            </div>
            <div className="viewport-wrapper" ref={viewportRef}>
                <p className="launch-time">
                    <span className="text" onClick={toCoupon}>
                        {t.rich('teaser.launch_time', {
                            line1: (children: any) => <span className="text">{children}</span>,
                            line2: (children: any) => <span className="text">{children}</span>,
                        })}
                    </span>
                </p>
                <p className="wave2">{t('wave2')}</p>
                <p className="slogan">{t('wave2slogan')}</p>
                <div className="subscribe">
                    <Subscribe />
                    {['us', 'ca'].includes(locale) && (
                        <div className="icon" onClick={toCoupon}>
                            <Upto off={locale === 'ca' ? '$800' : '$700'} />
                            {/* <NextImage
                            webpSrc={require('@publicLocal/up_to.webp')}
                            src={require('@publicLocal/up_to.png')}
                            alt={t('wave2')}
                            aria-label={t('wave2')}
                        /> */}
                        </div>
                    )}
                </div>
            </div>
            <p className="green-text">{t('teaser.sectionA_desc')}</p>
        </div>
    );
}
